import React from "react";
import { Link } from "react-router-dom";
const Footer = () => {
  return (
    <div className="footer">
      {/* <h3 className="text-center">Copyright &copy; AnyTrade</h3> */}
        <p className="text-center fw-3 fw-bold font-bold my-2">
          copyright &copy;
          <abbr className="text-warning"> AnyTrade</abbr>
        </p>
        <p className="text-center fw-3 fw-bold font-bold my-2">
           Designed & Developed By Team
           <abbr className="text-warning"> SE-ECE</abbr>
        </p>
      <p className="text-center mt-3">
        <Link to="/about">About</Link>|<Link to="/contact">Contact</Link>|
        <Link to="/policy">Privacy Policy</Link>
      </p>
    </div>
  );
};

export default Footer;
